export function downloadFile(objectUrl, filename) {
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  a.target = "_blank";
  a.click();
}
